import { appConfig } from "@quest/appConfig";
import { keycloak } from "@quest/keycloakConfig";
import { getPublicIP } from "./get-public-ip";
import axios from "axios";

export const superAdminAxiosInstance = axios.create({
  baseURL: `${appConfig.apiUrl}/api/v1`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

superAdminAxiosInstance.interceptors.request.use(async (config) => {
  const ip = await getPublicIP();
  config.headers["x-header-ip"] = ip;
  return config;
});

superAdminAxiosInstance.interceptors.request.use(
  async (config) => {
    const token = keycloak.token;

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

superAdminAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshed = await keycloak.updateToken(30);
        if (refreshed) {
          originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
          return axios(originalRequest);
        } else {
          keycloak.logout();
        }
      } catch (err) {
        keycloak.logout();
      }
    } else if (error.response?.status === 403) {
      window.location.href = "/unauthorized";
    }

    return Promise.reject(error);
  }
);

export default superAdminAxiosInstance;
export { getPublicIP };

